const ORDER_CENTER = {
  ORDER_CENTER_CALL_TYPE: {
    10: {
      value: 10,
      desc: '司机主叫'
    },
    11: {
      value: 11,
      desc: '乘客主叫'
    },
    12: {
      value: 12,
      desc: '短信发送'
    },
    13: {
      value: 13,
      desc: '短信接收'
    },
    20: {
      value: 20,
      desc: '呼叫不允许'
    },
    21: {
      value: 21,
      desc: '未开户不允许'
    },
    30: {
      value: 30,
      desc: '短信不允许'
    },
    126: {
      value: 126,
      desc: '双呼'
    }
  }
}
export default ORDER_CENTER
